export default __webpack_public_path__ + "static/media/carnival6.4b12629a.jpeg";